import ls from '../LStorage';
import menu from './menu'

export default {
  state: {
    user: ls.getItem('user') || {},
	  userId: ls.getItem('userId') || '',
    access_token: ls.getItem('access_token') || '',
    refresh_token: ls.getItem('refresh_token') || '',
    isLogin: ls.getItem('isLogin') || false,
    isAgree: ls.getItem('isAgree') || false,
    isOpen: ls.getItem('isOpen') || false,
    openObj: ls.getItem('openObj') || {},
    org: ls.getItem('org') || '',
    choperatorcode: ls.getItem('choperatorcode') || '',
    corporation: ls.getItem('corporation') || '',
    completeFlag:ls.getItem('completeFlag') || '',
    encryptAlgorithm:ls.getItem('encryptAlgorithm') || ''
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
	  ls.setItem('user', user);
    },
    setCorporation(state, corporation) {
         state.corporation = corporation;
         ls.setItem('corporation', corporation);
    },
    setOrg(state, org) {
      state.org = org;
	  ls.setItem('org', org);
    },
	setUserId(state, id) {
      state.userId = id;
	  ls.setItem('userId', id);
    },
    setChoperatorcode(state, code) {
      state.choperatorcode = code;
	  ls.setItem('choperatorcode', code);
    },
    setAccess(state, token) {
      state.access_token = token;
      ls.setItem('access_token', token);
    },
    setRefresh(state, token) {
      state.refresh_token = token;
      ls.setItem('refresh_token', token);
    },
    isLogin(state, bo) {
      state.isLogin = bo;
      if(bo){
        ls.setItem('isLogin', bo)
      }else{
		    menu.state.list = [];
        ls.clear();
      }
    },
    isAgree(state,msg){
      state.isAgree = msg;
      ls.setItem('isAgree', msg);
    },
    isOpen(state,msg){
      state.isOpen = msg;
      ls.setItem('isOpen', msg);
    },
    openObj(state,msg){
      state.openObj = msg;
      ls.setItem('openObj', msg);
    },
    setCompleteFlag(state,msg){
        state.completeFlag = msg;
        ls.setItem('completeFlag', msg);
    },
    setEncryptAlgorithm(state,msg){
        state.encryptAlgorithm = msg;
        ls.setItem('encryptAlgorithm', msg);
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/module/user.js